import SvgIcon from "@mui/material/SvgIcon";

const PRIMARY = "#7f7f7f";
const WHITE = "#ffffff";

const connectors = [
  { x1: 55, y1: 55, x2: 115, y2: 55 },
  { x1: 55, y1: 55, x2: 55, y2: 125 },
  { x1: 115, y1: 55, x2: 115, y2: 125 },
  { x1: 55, y1: 125, x2: 115, y2: 125 },
  { x1: 115, y1: 55, x2: 150, y2: 25 },
];

const baseCircles = [
  { cx: 55, cy: 55 },
  { cx: 115, cy: 55 },
  { cx: 55, cy: 125 },
  { cx: 115, cy: 125 },
];

function ServicesIcon(props) {
  return (
    <SvgIcon viewBox="0 0 180 180" {...props}>
      <g stroke={WHITE} strokeWidth={24} strokeLinecap="round" strokeLinejoin="round" fill="none">
        {connectors.map(({ x1, y1, x2, y2 }) => (
          <line key={`bg-${x1}-${y1}-${x2}-${y2}`} x1={x1} y1={y1} x2={x2} y2={y2} />
        ))}
      </g>
      <g stroke={PRIMARY} strokeWidth={12} strokeLinecap="round" strokeLinejoin="round" fill="none">
        {connectors.map(({ x1, y1, x2, y2 }) => (
          <line key={`fg-${x1}-${y1}-${x2}-${y2}`} x1={x1} y1={y1} x2={x2} y2={y2} />
        ))}
      </g>
      {baseCircles.map(({ cx, cy }) => (
        <circle
          key={`node-${cx}-${cy}`}
          cx={cx}
          cy={cy}
          r={32}
          fill={PRIMARY}
          stroke={WHITE}
          strokeWidth={10}
        />
      ))}
      <circle cx={150} cy={25} r={26} fill={WHITE} stroke={PRIMARY} strokeWidth={10} />
    </SvgIcon>
  );
}

export default ServicesIcon;
